import './plugins/jquery.height.js';
import './plugins/jquery.sumoselect.min.js';
import utils from './utils';

utils();


// WEBPACK FOOTER //
// ./src/assets/js/main.js